import React from 'react'
import { useSelector } from 'react-redux'
import { Navigate, Outlet } from 'react-router-dom'

function AuthProtect() {

  const currentUser = useSelector((state) => state.user.userLoginToken)

  return (
    currentUser ? <Outlet /> : <Navigate to='/login'></Navigate>
  )
}

export default AuthProtect;